import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={19.914}
      height={17.078}
      viewBox="0 0 19.914 17.078"
      {...props}
    >
      <path
        fill="#fff"
        d="M18.716 7.141a1.424 1.424 0 00-.246-.018H4.421l.306-.142a2.849 2.849 0 00.805-.57l3.94-3.94A1.475 1.475 0 009.679.583 1.425 1.425 0 007.542.398L.418 7.522a1.425 1.425 0 000 2.015l7.124 7.121a1.425 1.425 0 002.137-.142 1.475 1.475 0 00-.207-1.888L5.54 10.685a2.85 2.85 0 00-.712-.52L4.4 9.972h13.992a1.475 1.475 0 001.5-1.2 1.425 1.425 0 00-1.176-1.631z"
      />
    </svg>
  );
}

export default SvgComponent;
